import { Box, Text, Tooltip } from "@chakra-ui/react";

import { useConfigurationThemeConsumer } from "ChakraTheme";

import { IconButton } from "components/IconButton";

const NormalLettersButton = () => {
  const { dispatch } = useConfigurationThemeConsumer();
  const normalLetterSizeMessage = "Normalna wielkość liter";

  return (
    <Box>
      <Tooltip
        label={normalLetterSizeMessage}
        aria-label={normalLetterSizeMessage}
      >
        <IconButton
          id="normal-letters-btn"
          aria-label={normalLetterSizeMessage}
          background="transparent"
          size="lg"
          icon={<Text fontSize="lg">A</Text>}
          onClick={() => dispatch({ type: "FONT_SIZE_NORMAL" })}
        />
      </Tooltip>
    </Box>
  );
};

export { NormalLettersButton };
